import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import {
  MatrixGalleryCarmiData,
  MatrixGalleryDefinition,
  MatrixGalleryProps,
} from '../MatrixGallery.types';
import { props as viewerPropsMapper } from './MatrixGallery.mapper';

export const props = composeMapper<
  MatrixGalleryProps,
  MatrixGalleryDefinition,
  MatrixGalleryCarmiData
>()(
  viewerPropsMapper,
  {
    add: ['shouldResetGalleryToOriginalState'],
  },
  (resolver, deps, carmiData) => {
    const { shouldResetGalleryToOriginalState } = deps;
    const viewerProps = resolver(deps, carmiData);

    return {
      ...viewerProps,
      previewWrapperProps: { shouldResetGalleryToOriginalState },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
